import I18n from 'i18n-js'

export const DUNNING_TABS_KEYS = {
  past_due_orders: 'past_due_orders',
  open: 'open',
  resolved: 'resolved',
  reports: 'reports',
  search: 'search',
}

export const POWER_SELLER_TABS = [
  {
    key: DUNNING_TABS_KEYS.open,
    label: I18n.t('react.shared.nav.open_claims'),
    link: '/cabinet/dunning/open',
  },
  {
    key: DUNNING_TABS_KEYS.resolved,
    label: I18n.t('react.shared.nav.resolved_claims'),
    link: '/cabinet/dunning/resolved',
  },
]

export const ADMIN_TABS = [
  {
    key: DUNNING_TABS_KEYS.past_due_orders,
    label: I18n.t('react.shared.nav.debt_orders'),
  },
  ...POWER_SELLER_TABS,
]

export const CABINET_TABS = [
  {
    key: DUNNING_TABS_KEYS.past_due_orders,
    label: I18n.t('react.shared.nav.debt_orders'),
    link: '/cabinet/dunning/past_due_orders',
  },
  ...POWER_SELLER_TABS,
  {
    key: DUNNING_TABS_KEYS.reports,
    label: I18n.t('react.shared.nav.inkasso_reports'),
    link: '/cabinet/dunning/reports',
  },
]

export const DUNNING_STRATEGIES: {
  dunning: 'dunning'
  dunning_inkasso: 'dunning_inkasso'
  inkasso: 'inkasso'
} = {
  dunning: 'dunning',
  dunning_inkasso: 'dunning_inkasso',
  inkasso: 'inkasso',
}

export const AUTO_STOP: {
  never: 'never'
  afterComplete: 'after_complete'
} = {
  never: 'never',
  afterComplete: 'after_complete',
}
export const DEBT_CONDITIONS: {
  amountFrom: 'amount_from'
  amountTo: 'amount_to'
  noCondition: 'no_condition'
} = {
  amountFrom: 'amount_from',
  amountTo: 'amount_to',
  noCondition: 'no_condition',
}

export const DUNNING_STRATEGY_STATUSES = {
  in_progress: 'in_progress',
  init: 'init',
  completed: 'completed',
  skipped: 'skipped',
}

export const CLAIM_LIFECYCLES: {
  dunning: 'dunning'
  dunningCompleted: 'dunning_completed'
  inkassoReady: 'inkasso_ready'
  inkassoActive: 'inkasso_active'
  inkassoPreCourt: 'inkasso_pre_court'
  inkassoCourt: 'inkasso_court'
  inkassoPostCourt: 'inkasso_post_court'
  closed: 'closed'
  dunningAfterDcaFailure: 'dunning_after_dca_failure'
  dunningCompletedAfterDcaFailure: 'dunning_completed_after_dca_failure'
  dunningAfterDcaManualResolution: 'dunning_after_dca_manual_resolution'
  dunningCompletedAfterDcaManualResolution: 'dunning_completed_after_dca_manual_resolution'
} = {
  dunning: 'dunning',
  dunningCompleted: 'dunning_completed',
  inkassoReady: 'inkasso_ready',
  inkassoActive: 'inkasso_active',
  inkassoPreCourt: 'inkasso_pre_court',
  inkassoCourt: 'inkasso_court',
  inkassoPostCourt: 'inkasso_post_court',
  closed: 'closed',
  dunningAfterDcaFailure: 'dunning_after_dca_failure',
  dunningCompletedAfterDcaFailure: 'dunning_completed_after_dca_failure',
  dunningAfterDcaManualResolution: 'dunning_after_dca_manual_resolution',
  dunningCompletedAfterDcaManualResolution: 'dunning_completed_after_dca_manual_resolution',
}

export const DUNNING_LIFECYCLES: string[] = [
  CLAIM_LIFECYCLES.dunning,
  CLAIM_LIFECYCLES.dunningAfterDcaFailure,
  CLAIM_LIFECYCLES.dunningAfterDcaManualResolution,
]

export const DUNNING_COMPLETED_LIFECYCLES: string[] = [
  CLAIM_LIFECYCLES.dunningCompleted,
  CLAIM_LIFECYCLES.dunningCompletedAfterDcaFailure,
  CLAIM_LIFECYCLES.dunningCompletedAfterDcaManualResolution,
]

export const INKASSO_LIFECYCLES: string[] = [
  CLAIM_LIFECYCLES.inkassoReady,
  CLAIM_LIFECYCLES.inkassoActive,
  CLAIM_LIFECYCLES.inkassoPreCourt,
  CLAIM_LIFECYCLES.inkassoCourt,
  CLAIM_LIFECYCLES.inkassoPostCourt,
]

export const CLAIM_OUTCOMES: {
  pending: 'pending'
  collected: 'collected'
  partiallyCollected: 'partially_collected'
  notCollected: 'not_collected'
  paidWithoutCollection: 'paid_without_collection'
  collectedUnpaid: 'collected_unpaid'
  partiallyCollectedUnpaid: 'partially_collected_unpaid'
  notCollectedPaid: 'not_collected_paid'
} = {
  pending: 'pending',
  collected: 'collected',
  partiallyCollected: 'partially_collected',
  notCollected: 'not_collected',
  paidWithoutCollection: 'paid_without_collection',
  collectedUnpaid: 'collected_unpaid',
  partiallyCollectedUnpaid: 'partially_collected_unpaid',
  notCollectedPaid: 'not_collected_paid',
}

export const COLLECTED_OUTCOMES: string[] = [CLAIM_OUTCOMES.collected, CLAIM_OUTCOMES.collectedUnpaid]

export const NOT_COLLECTED_OUTCOMES: string[] = [CLAIM_OUTCOMES.notCollected, CLAIM_OUTCOMES.notCollectedPaid]

export const PARTIALLY_COLLECTED_OUTCOMES: string[] = [
  CLAIM_OUTCOMES.partiallyCollected,
  CLAIM_OUTCOMES.partiallyCollectedUnpaid,
]

export const PAID_OUTCOMES: string[] = [
  CLAIM_OUTCOMES.collected,
  CLAIM_OUTCOMES.partiallyCollected,
  CLAIM_OUTCOMES.notCollectedPaid,
  CLAIM_OUTCOMES.paidWithoutCollection,
]

export const CLAIM_PROCESSING_STATUSES: {
  active: 'active'
  paused: 'paused'
} = {
  active: 'active',
  paused: 'paused',
}

export const INKASSO_STRATEGY_STATUSES = {
  sendToInkasso: 'in_inkasso',
  readyForInkasso: 'ready_for_inkasso',
  inkassoCollected: 'collected',
  inkassoNotCollected: 'inkasso_not_collected',
  notReadyForInkasso: 'not_ready_for_inkasso',
  preCourt: 'pre_court',
  court: 'court',
  postCourt: 'post_court',
  paused: 'paused',
}

export const OPEN_CLAIMS_ACTIONS = {
  stop: 'stop',
  collected: 'collected',
  not_collected: 'not_collected',
  send_to_inkasso: 'send_to_inkasso',
  stop_dunning: 'stop_dunning',
  recall_from_agency: 'recall_from_agency',
  resolve: 'resolve',
}
export const getOpenClaimsActionsLabels = (count) => ({
  stop: I18n.t('react.cabinet.dunning.shared.notify.stop', { count }),
  collected: I18n.t('react.cabinet.dunning.shared.notify.collected', { count }),
  not_collected: I18n.t('react.cabinet.dunning.shared.notify.not_collected', { count }),
  send_to_inkasso: I18n.t('react.cabinet.dunning.shared.notify.send_to_inkasso', { count }),
})
export const STRATEGY_STATUS_TYPE_OPTIONS = {
  collected: 'collected',
  manually_resolved_dunning: 'manually_resolved_dunning',
  manually_resolved_inkasso: 'manually_resolved_inkasso',
  not_collected: 'not_collected',
}

export const OUTCOME_STATUSES = {
  paid: 'paid',
  unpaid: 'unpaid',
}

export const COUNT = {
  SINGLE: 1,
}

export const NOTE_MAX_LENGTH = 1000

export const EMAIL_COUNT = 3

export const PDF_URL = '/cabinet/financial_reports/report.pdf'

export const NO_COLLECTED_REASON_LENGTH = 30
export const INKASSO_REPORTS_CSV_PARAMS = [
  {
    label: I18n.t('react.shared.transfers.csv.id'),
    csvKey: 'id_for_seller',
  },
  {
    label: I18n.t('react.shared.transfers.csv.related_id'),
    csvKey: 'related_id',
  },
  {
    label: I18n.t('react.cabinet.common.invoice_number'),
    csvKey: 'invoice_number',
  },
  {
    label: I18n.t('react.shared.transfers.csv.memo'),
    csvKey: 'credit_memo_number',
  },
  {
    label: I18n.t('react.shared.transfers.csv.date'),
    csvKey: 'created',
  },
  {
    label: I18n.t('react.shared.transfers.csv.success_date'),
    csvKey: 'success_date',
  },
  {
    label: I18n.t('react.shared.transfers.csv.type'),
    csvKey: 'type',
  },
  {
    label: I18n.t('react.shared.transfers.csv.form'),
    csvKey: 'form',
  },
  {
    label: I18n.t('react.shared.transfers.csv.product_id'),
    csvKey: 'product_id',
  },
  {
    label: I18n.t('react.shared.transfers.csv.product'),
    csvKey: 'product_name',
  },
  {
    label: I18n.t('react.shared.transfers.csv.provider'),
    csvKey: 'provider',
  },
  {
    label: I18n.t('react.shared.transfers.csv.status'),
    csvKey: 'status',
  },
  {
    label: I18n.t('react.shared.transfers.csv.ps'),
    csvKey: 'power_seller',
  },
  {
    label: I18n.t('react.shared.transfers.csv.inst'),
    csvKey: 'to_be_paid',
  },
  {
    label: I18n.t('react.shared.transfers.csv.total'),
    csvKey: 'total',
  },
  {
    label: I18n.t('react.shared.transfers.csv.amount'),
    csvKey: 'amount',
  },
  {
    label: I18n.t('react.shared.transfers.csv.currency'),
    csvKey: 'currency_key',
  },
  {
    label: I18n.t('react.shared.transfers.csv.fee'),
    csvKey: 'fee',
  },
  {
    label: I18n.t('react.shared.transfers.csv.service_fee'),
    csvKey: 'service_fee',
  },
  {
    label: I18n.t('react.shared.transfers.csv.publisher_fee'),
    csvKey: 'publisher_fee',
  },
  {
    label: I18n.t('react.shared.transfers.csv.jv_fee'),
    csvKey: 'jv_fee',
  },
  {
    label: I18n.t('react.shared.transfers.csv.stm_fee_payout_via_ablefy'),
    csvKey: 'stm_fee_payout_via_ablefy',
  },
  {
    label: I18n.t('react.shared.transfers.csv.processing_fee'),
    csvKey: 'processing_fee',
  },
  {
    label: I18n.t('react.shared.transfers.csv.vat_rate'),
    csvKey: 'vat_rate',
  },
  {
    label: I18n.t('react.shared.transfers.csv.vat_amount'),
    csvKey: 'vat_amount',
  },
  {
    label: I18n.t('react.shared.transfers.csv.seller_business'),
    csvKey: 'seller_business',
  },
  {
    label: I18n.t('react.shared.transfers.csv.product_name'),
    csvKey: 'sellable_name',
  },
  {
    label: I18n.t('react.shared.transfers.csv.buyer_first_name'),
    csvKey: 'first_name',
  },
  {
    label: I18n.t('react.shared.transfers.csv.buyer_last_name'),
    csvKey: 'last_name',
  },
  {
    label: I18n.t('react.shared.transfers.csv.buyer_email'),
    csvKey: 'email',
  },
  {
    label: I18n.t('react.shared.transfers.csv.buyer_phone'),
    csvKey: 'buyer_phone',
  },
  {
    label: I18n.t('react.shared.transfers.csv.buyer_country'),
    csvKey: 'buyer_country',
  },
  {
    label: I18n.t('react.shared.transfers.csv.buyer_city'),
    csvKey: 'city',
  },
  {
    label: I18n.t('react.shared.transfers.csv.buyer_street'),
    csvKey: 'street',
  },
  {
    label: I18n.t('react.shared.transfers.csv.buyer_street_number'),
    csvKey: 'street_number',
  },
  {
    label: I18n.t('react.shared.transfers.csv.buyer_zip'),
    csvKey: 'zip',
  },
  {
    label: I18n.t('react.cabinet.common.order_id'),
    csvKey: 'order_id',
  },
  {
    label: I18n.t('react.shared.transfers.csv.order_rate_id'),
    csvKey: 'order_rate_id',
  },
  {
    label: I18n.t('react.common.net'),
    csvKey: 'net',
  },
  {
    label: I18n.t('react.shared.ext_id'),
    csvKey: 'ext_id',
  },
  {
    label: I18n.t('react.common.credit_memo_nr'),
    csvKey: 'payout_numbers',
  },
  {
    label: I18n.t('react.shared.transfers.csv.earnings'),
    csvKey: 'earnings',
  },
  {
    label: I18n.t('react.cabinet.common.invoice_id'),
    csvKey: 'invoice_id',
  },
  {
    label: I18n.t('react.cabinet.common.transfer_payer_country'),
    csvKey: 'transfer_payer_country',
  },
  {
    label: I18n.t('react.cabinet.common.invoice_date'),
    csvKey: 'invoice_created_at',
  },
]

export const AUTO_RESOLVED_STATUS_KEY = 'auto_resolved_dunning'

export const DUNNING_STATUS_LABELS = {
  1: I18n.t('react.cabinet.dunning.status.1'),
  2: I18n.t('react.cabinet.dunning.status.2'),
  3: I18n.t('react.cabinet.dunning.status.3'),
  collected: I18n.t('react.cabinet.dunning.status.collected'),
  completed: I18n.t('react.cabinet.dunning.status.completed'),
  court: I18n.t('react.cabinet.dunning.status.court'),
  in_inkasso: I18n.t('react.cabinet.dunning.status.in_inkasso'),
  inkasso_collected: I18n.t('react.cabinet.dunning.status.inkasso_collected'),
  inkasso_not_collected: I18n.t('react.cabinet.dunning.status.inkasso_not_collected'),
  inkasso_status: I18n.t('react.cabinet.dunning.status.inkasso_status'),
  in_progress: I18n.t('react.cabinet.dunning.status.in_progress'),
  manually_resolved_dunning: I18n.t('react.cabinet.dunning.status.manually_resolved_dunning'),
  manually_resolved_inkasso: I18n.t('react.cabinet.dunning.status.manually_resolved_inkasso'),
  no: I18n.t('react.cabinet.dunning.status.no'),
  not_collected: I18n.t('react.cabinet.dunning.status.not_collected'),
  not_ready_for_inkasso: I18n.t('react.cabinet.dunning.status.not_ready_for_inkasso'),
  outcome_status: I18n.t('react.cabinet.dunning.status.outcome_status'),
  paid: I18n.t('react.cabinet.dunning.status.paid'),
  partially_collected: I18n.t('react.cabinet.dunning.status.partially_collected'),
  paused: I18n.t('react.cabinet.dunning.status.paused'),
  post_court: I18n.t('react.cabinet.dunning.status.post_court'),
  pre_court: I18n.t('react.cabinet.dunning.status.pre_court'),
  ready_for_inkasso: I18n.t('react.cabinet.dunning.status.ready_for_inkasso'),
  send_to_dca: I18n.t('react.cabinet.dunning.status.send_to_dca'),
  skipped: I18n.t('react.cabinet.dunning.status.skipped'),
  stop_blocked: I18n.t('react.cabinet.dunning.status.stop_blocked'),
  [AUTO_RESOLVED_STATUS_KEY]: I18n.t('react.cabinet.dunning.status.auto_resolved_dunning'),
}
export const getDunningStageLabels = (count) => ({
  1: I18n.t('react.cabinet.dunning.status.stage_1', { count }),
  2: I18n.t('react.cabinet.dunning.status.stage_2', { count }),
  3: I18n.t('react.cabinet.dunning.status.stage_3', { count }),
  court: I18n.t('react.cabinet.dunning.status.stage_court'),
  in_inkasso: I18n.t('react.cabinet.dunning.status.stage_in_inkasso'),
  post_court: I18n.t('react.cabinet.dunning.status.stage_post_court'),
  pre_court: I18n.t('react.cabinet.dunning.status.stage_pre_court'),
  ready_for_inkasso: I18n.t('react.cabinet.dunning.status.stage_ready_for_inkasso'),
})

export const CLAIM_LIFECYCLE_LABELS = {
  [CLAIM_LIFECYCLES.dunning]: I18n.t('react.cabinet.dunning.status.lifecycle_dunning'),
  [CLAIM_LIFECYCLES.dunningCompleted]: I18n.t('react.cabinet.dunning.status.lifecycle_dunning_completed'),
  [CLAIM_LIFECYCLES.inkassoReady]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_ready'),
  [CLAIM_LIFECYCLES.inkassoActive]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_active'),
  [CLAIM_LIFECYCLES.inkassoPreCourt]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_pre_court'),
  [CLAIM_LIFECYCLES.inkassoCourt]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_court'),
  [CLAIM_LIFECYCLES.inkassoPostCourt]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_post_court'),
  [CLAIM_LIFECYCLES.closed]: I18n.t('react.cabinet.dunning.status.lifecycle_closed'),
  [CLAIM_LIFECYCLES.dunningAfterDcaFailure]: I18n.t('react.cabinet.dunning.status.lifecycle_dunning_after_dca_failure'),
  [CLAIM_LIFECYCLES.dunningCompletedAfterDcaFailure]: I18n.t(
    'react.cabinet.dunning.status.lifecycle_dunning_completed_after_dca_failure'
  ),
  [CLAIM_LIFECYCLES.dunningAfterDcaManualResolution]: I18n.t(
    'react.cabinet.dunning.status.lifecycle_dunning_after_dca_manual_resolution'
  ),
  [CLAIM_LIFECYCLES.dunningCompletedAfterDcaManualResolution]: I18n.t(
    'react.cabinet.dunning.status.lifecycle_dunning_completed_after_dca_manual_resolution'
  ),
}

export const CLAIM_OUTCOME_LABELS = {
  [CLAIM_OUTCOMES.pending]: I18n.t('react.cabinet.dunning.status.outcome_pending'),
  [CLAIM_OUTCOMES.collected]: I18n.t('react.cabinet.dunning.status.outcome_collected'),
  [CLAIM_OUTCOMES.partiallyCollected]: I18n.t('react.cabinet.dunning.status.outcome_partially_collected'),
  [CLAIM_OUTCOMES.notCollected]: I18n.t('react.cabinet.dunning.status.outcome_not_collected'),
  [CLAIM_OUTCOMES.paidWithoutCollection]: I18n.t('react.cabinet.dunning.status.outcome_paid_without_collection'),
  [CLAIM_OUTCOMES.collectedUnpaid]: I18n.t('react.cabinet.dunning.status.outcome_collected_unpaid'),
  [CLAIM_OUTCOMES.partiallyCollectedUnpaid]: I18n.t('react.cabinet.dunning.status.outcome_partially_collected_unpaid'),
  [CLAIM_OUTCOMES.notCollectedPaid]: I18n.t('react.cabinet.dunning.status.outcome_not_collected_paid'),
}

export const CLAIM_PROCESSING_STATUS_LABELS = {
  [CLAIM_PROCESSING_STATUSES.active]: I18n.t('react.cabinet.dunning.status.processing_active'),
  [CLAIM_PROCESSING_STATUSES.paused]: I18n.t('react.cabinet.dunning.status.processing_paused'),
}

export const CLAIM_LIFECYCLE_TOOLTIPS = {
  [CLAIM_LIFECYCLES.dunning]: I18n.t('react.cabinet.dunning.status.lifecycle_dunning_expl'),
  [CLAIM_LIFECYCLES.dunningCompleted]: I18n.t('react.cabinet.dunning.status.lifecycle_dunning_completed_expl'),
  [CLAIM_LIFECYCLES.inkassoReady]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_ready_expl'),
  [CLAIM_LIFECYCLES.inkassoActive]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_active_expl'),
  [CLAIM_LIFECYCLES.inkassoPreCourt]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_pre_court_expl'),
  [CLAIM_LIFECYCLES.inkassoCourt]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_court_expl'),
  [CLAIM_LIFECYCLES.inkassoPostCourt]: I18n.t('react.cabinet.dunning.status.lifecycle_inkasso_post_court_expl'),
  [CLAIM_LIFECYCLES.closed]: I18n.t('react.cabinet.dunning.status.lifecycle_closed_expl'),
  [CLAIM_LIFECYCLES.dunningAfterDcaFailure]: I18n.t(
    'react.cabinet.dunning.status.lifecycle_dunning_after_dca_failure_expl'
  ),
  [CLAIM_LIFECYCLES.dunningCompletedAfterDcaFailure]: I18n.t(
    'react.cabinet.dunning.status.lifecycle_dunning_completed_after_dca_failure_expl'
  ),
  [CLAIM_LIFECYCLES.dunningAfterDcaManualResolution]: I18n.t(
    'react.cabinet.dunning.status.lifecycle_dunning_after_dca_manual_resolution_expl'
  ),
  [CLAIM_LIFECYCLES.dunningCompletedAfterDcaManualResolution]: I18n.t(
    'react.cabinet.dunning.status.lifecycle_dunning_completed_after_dca_manual_resolution_expl'
  ),
}

export const CLAIM_OUTCOME_TOOLTIPS = {
  [CLAIM_OUTCOMES.pending]: I18n.t('react.cabinet.dunning.status.outcome_pending_expl'),
  [CLAIM_OUTCOMES.collected]: I18n.t('react.cabinet.dunning.status.outcome_collected_expl'),
  [CLAIM_OUTCOMES.partiallyCollected]: I18n.t('react.cabinet.dunning.status.outcome_partially_collected_expl'),
  [CLAIM_OUTCOMES.notCollected]: I18n.t('react.cabinet.dunning.status.outcome_not_collected_expl'),
  [CLAIM_OUTCOMES.paidWithoutCollection]: I18n.t('react.cabinet.dunning.status.outcome_paid_without_collection_expl'),
  [CLAIM_OUTCOMES.collectedUnpaid]: I18n.t('react.cabinet.dunning.status.outcome_collected_unpaid_expl'),
  [CLAIM_OUTCOMES.partiallyCollectedUnpaid]: I18n.t(
    'react.cabinet.dunning.status.outcome_partially_collected_unpaid_expl'
  ),
  [CLAIM_OUTCOMES.notCollectedPaid]: I18n.t('react.cabinet.dunning.status.outcome_not_collected_paid_expl'),
}

export const CLAIM_PROCESSING_STATUS_TOOLTIPS = {
  [CLAIM_PROCESSING_STATUSES.active]: I18n.t('react.cabinet.dunning.status.processing_active_expl'),
  [CLAIM_PROCESSING_STATUSES.paused]: I18n.t('react.cabinet.dunning.status.processing_paused_expl'),
}

export const DUNNING_STRATEGY_LABELS = {
  dunning: I18n.t('react.cabinet.dunning.shared.strategy.dunning'),
  dunning_inkasso: I18n.t('react.cabinet.dunning.shared.strategy.dunning_inkasso'),
  inkasso: I18n.t('react.cabinet.dunning.shared.strategy.inkasso'),
}

export const INKASSO_REPORTS_FORM = {
  inkassoBalance: 'inkasso_balance',
  ecollectBalance: 'e_collect_inkasso_balance',
}
